import React, { Component } from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { connect } from 'react-redux';

class ComparisonTable extends Component {
  render() {
    return (
      <div>
        <BootstrapTable
          tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
          keyField="id"
          data={ this.props.comparisons }
          columns={ this.props.columns }
          striped
          hover
          condensed
          noDataIndication={this.props.translations.no_comparison}
          defaultChecked={ false }
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ComparisonTable);



// WEBPACK FOOTER //
// ./src/components/comparison_table.js